"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mortgageObligation = void 0;
var joi_1 = __importDefault(require("joi"));
exports.mortgageObligation = joi_1.default.object({
    annualTax: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    borrowerTypeID: joi_1.default.number()
        .min(0)
        .integer()
        .max(99)
        .required(),
    currentMarketValue: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    nationalHousingActInsured: joi_1.default.boolean().required(),
    registeredMortgageHolder: joi_1.default.string()
        .min(0)
        .max(30)
        .required(),
    requiredMonthlyPaymentPrincipalInterest: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    municipalityName: joi_1.default.string()
        .min(0)
        .max(20)
        .required(),
    postalCode: joi_1.default.string()
        .min(0)
        .max(6)
        .required(),
    provinceCode: joi_1.default.string()
        .min(0)
        .max(2)
        .required(),
    streetDirection: joi_1.default.string()
        .min(0)
        .max(2)
        .optional()
        .allow(''),
    streetName: joi_1.default.string()
        .min(0)
        .max(30)
        .required(),
    streetNumber: joi_1.default.string()
        .min(0)
        .max(7)
        .required(),
    streetType: joi_1.default.string()
        .min(0)
        .max(6)
        .required(),
    unitNumber: joi_1.default.string()
        .min(0)
        .max(6)
        .optional()
        .allow(''),
    unpaidBalance: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
});
exports.default = { mortgageObligation: exports.mortgageObligation };
